import { Product } from '@virginexperiencedays/products';
import { VALID_B2B_ROUTES } from './constants';

export const isB2bProduct = (product: Product) =>
  product?.facets?.occasions?.some((occasion) => VALID_B2B_ROUTES.includes(occasion));
